/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Florian Hartl <f.hartl@techdivision.com>
 */

import * as React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * ErrorTemplate Component
 * @returns {JSX.Element}
 * @constructor
 */
export default function ErrorTemplate() {
  const { t } = useTranslation();

  return <Box>{t('ERROR_MESSAGE')}</Box>;
}
